import type { AfterViewInit } from '@angular/core';
import { Component } from '@angular/core';
import { Validators } from '@angular/forms';

import type { Observable } from 'rxjs';
import { map, of, tap } from 'rxjs';

import { RECAPTCHA_FORBIDDEN } from '@valk-nx/core/lib/core';

import { RecaptchaV2BaseComponent } from './recaptchaV2-base';

@Component({
	selector: 'formly-field-recaptcha-v2-fallback',
	template: `
		@if (usingV2$ | async) {
			<re-captcha
				[errorMode]="props['errorMode']"
				[formControl]="formControl"
				[siteKey]="props['siteKey']"
				[size]="props['size']"
				(error)="onError($event)"
				class="my-4 block"
			/>
		}
	`,
	standalone: false,
})
export class RecaptchaV2FallbackComponent
	extends RecaptchaV2BaseComponent
	implements AfterViewInit
{
	usingV2$: Observable<boolean>;

	ngAfterViewInit() {
		const fallbackTrigger = this.field.props['fallbackToV2Trigger'];
		if (fallbackTrigger) {
			this.usingV2$ = fallbackTrigger.pipe(
				tap(() => this.formControl.reset()),
				map((val) => val === RECAPTCHA_FORBIDDEN),
				tap((usingV2: boolean) => this.setRequired(usingV2)),
			);
		} else {
			this.usingV2$ = of(true);
			this.setRequired(true);
		}
	}

	// While the v2 checkbox is shown, the form must not be submittable
	// without a token: a submit without one falls back to v3, which the
	// backend already rejected when it forced the v2 flow.
	private setRequired(required: boolean): void {
		if (required) {
			this.formControl.addValidators(Validators.required);
		} else {
			this.formControl.removeValidators(Validators.required);
		}
		this.formControl.updateValueAndValidity({ emitEvent: false });
	}
}
